import { useEffect, useState } from "react";
import { X, Plus, Link as LinkIco } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";

const feil = (e) => toast.error(formatApiError(e?.response?.data?.detail) || "Noe gikk galt");

export const STATUS_FARGE = { inbox: "#98A2B3", todo: "#0EA5E9", doing: "#D97706", done: "#10B981" };
export const STATUS_LABEL = { inbox: "Innboks", todo: "To do", doing: "Pågår", done: "Ferdig" };

export const SakKobling = ({ doc, linkedTasks, onOppdater, aktor }) => {
  const [aapen, setAapen] = useState(false);
  const [sok, setSok] = useState("");
  const [tasks, setTasks] = useState([]);
  const [nyTittel, setNyTittel] = useState("");

  useEffect(() => {
    if (!aapen) return;
    api.get("/admin/tasks").then(({ data }) => setTasks(data.tasks || [])).catch(() => {});
  }, [aapen]);

  const koble = async (tid) => {
    const ids = [...new Set([...(doc.linkedTaskIds || []), tid])];
    await onOppdater({ linkedTaskIds: ids });
    setAapen(false);
  };
  const fjern = async (tid) => {
    await onOppdater({ linkedTaskIds: (doc.linkedTaskIds || []).filter((x) => x !== tid) });
  };
  const opprettSak = async () => {
    const tittel = nyTittel.trim();
    if (!tittel) return;
    try {
      const { data } = await api.post("/admin/tasks", { title: tittel, status: "todo", actor: aktor });
      await koble(data.item?.id || data.task?.id || data.id);
      setNyTittel("");
      toast.success("Sak opprettet og koblet til dokumentet");
    } catch (e) { feil(e); }
  };

  const treff = tasks
    .filter((t) => !(doc.linkedTaskIds || []).includes(t.id) && !t.archived)
    .filter((t) => t.title.toLowerCase().includes(sok.trim().toLowerCase()))
    .slice(0, 8);

  return (
    <div className="flex flex-wrap items-center gap-1.5" data-testid="dok-saker">
      {linkedTasks.map((t) => (
        <span key={t.id} className="group inline-flex items-center gap-2 text-[12px] font-medium rounded-full border border-[#E7E4DB] bg-white px-3 py-1.5 text-neutral-600" data-testid={`dok-sak-${t.id}`}>
          <span className="w-1.5 h-1.5 rounded-full" style={{ background: STATUS_FARGE[t.status] || "#98A2B3" }} />
          <span className="max-w-[220px] truncate">{t.title}</span>
          <span className="text-neutral-300">{STATUS_LABEL[t.status] || t.status}</span>
          <button type="button" onClick={() => fjern(t.id)} className="opacity-0 group-hover:opacity-100 text-neutral-300 hover:text-red-500 transition-opacity" title="Fjern kobling" data-testid={`dok-sak-fjern-${t.id}`}>
            <X size={11} />
          </button>
        </span>
      ))}
      <div className="relative">
        <button type="button" onClick={() => setAapen((v) => !v)}
          className="inline-flex items-center gap-1.5 text-[12px] font-medium text-neutral-400 rounded-full border border-dashed border-[#D8D4C8] px-3 py-1.5 hover:text-neutral-800 hover:border-neutral-400 transition-colors"
          data-testid="dok-koble-sak-btn">
          <LinkIco size={11} /> Koble sak
        </button>
        {aapen && (
          <>
            <div className="fixed inset-0 z-30" onClick={() => setAapen(false)} />
            <div className="sak-modal absolute left-0 top-full mt-1.5 z-40 w-[290px] bg-white border border-[#E7E4DB] rounded-xl shadow-xl p-2" data-testid="dok-koble-meny">
              <input value={sok} onChange={(e) => setSok(e.target.value)} placeholder="Søk i saker …" autoFocus
                className="w-full text-[12px] border border-[#E7E4DB] rounded-lg px-2.5 py-1.5 bg-white focus:outline-none focus:border-neutral-400 mb-1.5"
                data-testid="dok-koble-sok" />
              <div className="max-h-[180px] overflow-y-auto">
                {treff.map((t) => (
                  <button key={t.id} type="button" onClick={() => koble(t.id)}
                    className="w-full flex items-center gap-2 px-2 py-1.5 rounded-lg text-[12px] text-left text-neutral-700 hover:bg-neutral-50 transition-colors"
                    data-testid={`dok-koble-valg-${t.id}`}>
                    <span className="w-1.5 h-1.5 rounded-full shrink-0" style={{ background: STATUS_FARGE[t.status] || "#98A2B3" }} />
                    <span className="truncate">{t.title}</span>
                  </button>
                ))}
                {treff.length === 0 && <p className="text-[11px] text-neutral-300 px-2 py-2">Ingen treff</p>}
              </div>
              <div className="border-t border-neutral-100 mt-1.5 pt-1.5 flex gap-1.5">
                <input value={nyTittel} onChange={(e) => setNyTittel(e.target.value)}
                  onKeyDown={(e) => { if (e.key === "Enter") opprettSak(); }}
                  placeholder="Ny sak fra dokumentet …"
                  className="flex-1 text-[12px] border border-[#E7E4DB] rounded-lg px-2.5 py-1.5 bg-white focus:outline-none focus:border-neutral-400"
                  data-testid="dok-ny-sak-input" />
                <button type="button" onClick={opprettSak} disabled={!nyTittel.trim()}
                  className="w-8 h-8 rounded-lg bg-neutral-900 text-white flex items-center justify-center disabled:opacity-40"
                  data-testid="dok-ny-sak-btn">
                  <Plus size={13} />
                </button>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};
